module.exports = {"title":"Games","layout":"page","path":"/games","body":"<h3><a href=\"https://concreted.github.io/pressxtojson\">pressxtojson</a> (2018)</h3>\n<p>quiz game to identify valid json.</p>\n<h3><a href=\"http://www.puzzlescript.net/play.html?p=93b93a3ccb38627817b2\">catrap</a>  (2015) [<a href=\"https://github.com/concreted/catrap\">code</a>]</h3>\n<h4></h4>\n<p>A port of the Game Boy game in <a href=\"%22http://www.puzzlescript.net/%22\">Puzzlescript</a>, with a C++/ImageMagick parser for converting screenshots into game levels.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./pages/games/index.md
// module id = 515
// module chunks = 0